import React from 'react'
import Header from '../header';
export default function boutUs() {
  return (
   < div className=' boardingTitle'>
    <div className='colorpage'>
<Header />
</div>

<div className="container-fluid">


<div className="row">
               <div className="col-lg-6">
               <h3 className='feature-text'>OVERVIEW</h3>
                    <p> At Dogtopia, we believe in safe socialization, exercise and education for your furry child. Our dog daycare centers provide the utmost in quality care as we separate each dog by size, temperament and promise evaluated, vaccinated dogs in a supervised environment.</p>
             <p>While our centers offer dog daycare, boarding and spa services (with some offering grooming and training). Daycare is a purposeful choice made for the love of your dog a selfless decision to ensure they are happy, healthy and equipped to become a well-rounded pup. Even our boarding services offer your pup an open-play environment to get them the socialization, exercise and education they deserve.</p>
              
                
               <h5 className='mt-3'>Follow us for your daily update</h5>
               <a href="/posh"> <i className="social-icon fab fa-facebook-square"></i></a>
   <a href="https://twitter.com/Posh_Mo"><i className="social-icon fab fa-twitter-square"></i></a>
   <a href="https://www.instagram.com/posh_mo/"><i className="social-icon fab fa-instagram"></i></a>
  <a href="/posh"> <i className="social-icon fas fa-envelope-square"></i></a>
               
                  
               </div>
               <div className="col-lg-6">
                
               <img className="contactimage2" src="images/doggy.jpeg" alt="iphone-mockup" />
                  
               </div>
           </div>

            
            </div>    
                   
                  
               


               
           {/* <!-- Footer -->  */}

   <footer id="footer"   >
       <div className='footerPositioning' >
   <a href="/posh"> <i className="social-icon fab fa-facebook-square"></i></a>
   <a href="https://twitter.com/Posh_Mo"><i className="social-icon fab fa-twitter-square"></i></a>
   <a href="https://www.instagram.com/posh_mo/"><i className="social-icon fab fa-instagram"></i></a>
  <a href = "mailto: ispeakfordogs@yahoo.com? subject = Feedback&body = Message"> <i className="social-icon fas fa-envelope-square"></i></a>
       <p>© Copyright PmPaws</p>
       </div>
   </footer>
</div>
  )
}
